import { Gradient } from 'types'
import { Icon } from 'ui'
import { UGELayerAction } from '../types'

export function gradientFromLayerAction(action: UGELayerAction): Gradient {
    switch (action) {
        case 'delete':
            return 'red-pink'
        case 'duplicate':
            return 'indigo-blue'
        case 'mirror':
            return 'indigo-purple'
        case 'send-to-back':
            return 'red-yellow'
    }
}

export function iconFromLayerAction(action: UGELayerAction): Icon {
    switch (action) {
        case 'delete':
            return 'trash'
        case 'duplicate':
            return 'duplicate'
        case 'mirror':
            return 'flip'
        case 'send-to-back':
            return 'send-back'
    }
}

export function labelFromLayerAction(action: UGELayerAction) {
    switch (action) {
        case 'delete':
            return 'Delete'
        case 'duplicate':
            return 'Duplicate'
        case 'mirror':
            return 'Flip'
        case 'send-to-back':
            return 'Send to Back'
    }
}

export function gaValueFromLayerAction(action: UGELayerAction) {
    switch (action) {
        case 'send-to-back':
            return 'send to back'
        default:
            return action
    }
}
